(function () {
  function initRecommendationsCarousel(container) {
    var attemptInit = function () {
      if (typeof jQuery === 'undefined' || typeof jQuery.fn.owlCarousel !== 'function') {
        window.setTimeout(attemptInit, 50);
        return;
      }

      var $container = jQuery(container);
      var $wrap = $container.find('.product-recommendations__carousel-wrap');
      var $carousel = $wrap.find('.product-recommendations__carousel');
      var $prev = $wrap.find('[data-recommendations-carousel-prev]');
      var $next = $wrap.find('[data-recommendations-carousel-next]');

      if (!$carousel.length) {
        return;
      }

      if ($carousel.hasClass('owl-loaded')) {
        $carousel.trigger('destroy.owl.carousel');
        $carousel.removeClass('owl-loaded owl-hidden');
      }

      var itemCount = $carousel.children('.product-recommendation-card').length;

      function updateNavVisibility() {
        var owl = $carousel.data('owl.carousel');
        var visibleItems = owl ? owl.settings.items : 2;
        var showNav = itemCount > visibleItems;

        $prev.toggle(showNav);
        $next.toggle(showNav);
      }

      $carousel.owlCarousel({
        loop: false,
        margin: 15,
        nav: false,
        dots: false,
        rewind: true,
        responsive: {
          0: {
            items: 2,
            margin: 10
          },
          768: {
            items: 3,
            margin: 12
          },
          992: {
            items: 5,
            margin: 15
          }
        }
      });

      $prev.off('click.recommendationsNav').on('click.recommendationsNav', function () {
        $carousel.trigger('prev.owl.carousel');
      });
      $next.off('click.recommendationsNav').on('click.recommendationsNav', function () {
        $carousel.trigger('next.owl.carousel');
      });

      $carousel
        .off('initialized.owl.carousel.recommendations resized.owl.carousel.recommendations')
        .on('initialized.owl.carousel.recommendations resized.owl.carousel.recommendations', updateNavVisibility);

      updateNavVisibility();
    };

    attemptInit();
  }

  if (customElements.get('product-recommendations')) {
    return;
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') {
        initRecommendationsCarousel(this);
        return;
      }

      var handleIntersection = function (entries, observer) {
        if (!entries[0].isIntersecting) {
          return;
        }

        observer.unobserve(this);
        this.loadRecommendations();
      }.bind(this);

      new IntersectionObserver(handleIntersection, {
        rootMargin: '0px 0px 400px 0px'
      }).observe(this);
    }

    loadRecommendations() {
      var url = this.dataset.url;

      if (!url) {
        return;
      }

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var recommendations = html.querySelector('product-recommendations');

          if (!recommendations || !recommendations.innerHTML.trim()) {
            this.remove();
            return;
          }

          this.innerHTML = recommendations.innerHTML;
          this.dataset.loaded = 'true';
          initRecommendationsCarousel(this);
        }.bind(this))
        .catch(function () {
          this.remove();
        }.bind(this));
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
